import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const allServiceLinks = [
  { key: 'equity', path: '/services/equity-trading', label: 'Equity Trading' },
  { key: 'pms', path: '/services/portfolio-management', label: 'Portfolio Management (PMS)' },
  { key: 'bonds', path: '/services/corporate-bonds', label: 'Corporate Bonds' },
  { key: 'gold', path: '/services/gold-bonds', label: 'Sovereign Gold Bonds' },
  { key: 'fd', path: '/services/fixed-deposits', label: 'NBFC Fixed Deposits' },
  { key: 'commodity', path: '/services/commodity-trading', label: 'Commodity Trading' },
  { key: 'mutualFund', path: '/mutual-fund-advisor', label: 'Mutual Fund Advisory' },
  { key: 'nri', path: '/nri-financial-planning', label: 'NRI Financial Planning' },
  { key: 'nriUK', path: '/nri/uk', label: 'NRI Services - UK' },
  { key: 'nriUAE', path: '/nri/uae', label: 'NRI Services - UAE' },
  { key: 'nriUS', path: '/nri/us', label: 'NRI Services - US' },
  { key: 'retirement', path: '/retirement-planning-india', label: 'Retirement Planning' },
  { key: 'wealth', path: '/wealth-management-services', label: 'Wealth Management' },
  { key: 'calculator', path: '/calculator', label: 'Investment Calculator' },
  { key: 'financial', path: '/financial-advisor-india', label: 'Financial Advisor India' },
];

function RelatedServices({ links }) {
  if (!links || links.length === 0) return null;

  const filtered = allServiceLinks.filter(item => links.indexOf(item.key) !== -1);
  if (filtered.length === 0) return null;

  return (
    <section className="py-16 bg-white border-t" data-testid="related-services">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center">Related Services</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="related-services-grid">
          {filtered.map(item => (
            <Link
              key={item.key}
              to={item.path}
              className="group flex items-center justify-between bg-gray-50 hover:bg-blue-50 rounded-xl px-5 py-4 transition-all border border-gray-200 hover:border-blue-300"
              data-testid={"related-" + item.key}
            >
              <span className="font-medium text-gray-800 group-hover:text-blue-900">{item.label}</span>
              <ArrowRight className="h-4 w-4 text-gray-400 group-hover:text-blue-600 transition-colors" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default RelatedServices;
